import services from "./servicesTour";
import workingHours from "./workingHoursTour";
import calendar from "./calendarTour";

export const TOURS = { services, workingHours, calendar };
export const TOUR_ORDER = ["services", "workingHours", "calendar"];
export const getTour = (id) => TOURS[id] || null;
